import React from 'react';
import styled from '@emotion/styled';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props =>
    props.hasNoBackground ? null : props.theme.colors.primary.lighter};
  padding: 20px 0;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1000px;
  width: 100%;

  @media (min-width: ${props =>
      props.theme.breakpoints.s}) and (max-width: ${props =>
      props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 35px 0;
  text-align: center;
  color: ${props => props.theme.colors.black.base};
`;
const Items = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
const Item = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  margin: 20px 0;
  max-width: 400px;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    min-width: 360px;
  }
`;
const ItemTitle = styled.h3`
  font-size: 16px;
  margin: 30px 0 0 0;
  min-height: 50px;
  text-align: center;
  line-height: 25px;
  font-weight: 600;
  color: ${props => props.theme.colors.black.light};
  font-family: ${props => props.theme.fontFamily.body};
`;

const WhyUs = props => {
  const { content, hasNoBackground, size } = props;
  const { title, items } = content ? content : {};
  const itemsRows = items ? chunkArrayInGroups(items, size ? size : 3) : [];

  return (
    <Section hasNoBackground={hasNoBackground}>
      <ContentWrapper>
        <SectionTitle>{title ? title : 'Why us?'}</SectionTitle>
        {itemsRows.map((items, rowIdx) => {
          return (
            <Items key={`row_${rowIdx}`}>
              {items.map((item, idx) => {
                const Icon = styled(item.icon)`
                  min-width: 65px;
                  height: 65px;
                `;
                return (
                  <Item key={idx}>
                    <Icon />
                    <ItemTitle>{item.title}</ItemTitle>
                  </Item>
                );
              })}
            </Items>
          );
        })}
      </ContentWrapper>
    </Section>
  );
};

const chunkArrayInGroups = (arr, size) => {
  let groups = [];
  for (let i = 0; i < arr.length; i += size) {
    groups.push(arr.slice(i, i + size));
  }
  return groups;
};

export default WhyUs;
